import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { TableActionButton } from "@components/common/table";
import { Note } from "@piiqtechnologies/svg-icons";
import { PeekDialog } from "@piiqtechnologies/ui-components";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import ScannerNotesDialog from "./ScannerNotesDialog";
export const ScannerNotesButton = ({ scanRequest }) => {
    const intl = useIntl();
    const [openScannerNotesDialog, setOpenScannerNotesDialog] = useState(false);
    const analytics = useAnalytics();
    const toggleScannerNotesDialog = useCallback(() => {
        !openScannerNotesDialog && analytics.track("Scanner Notes - Open");
        setOpenScannerNotesDialog(!openScannerNotesDialog);
    }, [openScannerNotesDialog]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TableActionButton, { "aria-label": "edit", "data-testid": "edit-request", height: 20, width: 20, onClick: toggleScannerNotesDialog, Icon: Note, tooltip: intl.formatMessage(messages.scannerNotesTitle) }),
        React.createElement(PeekDialog, { fullWidth: true, hasCloseIcon: true, disablePortal: true, maxWidth: "xs", open: openScannerNotesDialog, onClose: toggleScannerNotesDialog, title: intl.formatMessage(messages.scannerNotesTitle) },
            React.createElement(ScannerNotesDialog, { scanRequest: scanRequest, toggleScannerNotesDialog: toggleScannerNotesDialog }))));
};
export default ScannerNotesButton;
